var _g, _path, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin_location",
    "data-name": "Pin location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 48.5,
    viewBox: "0 0 32 48.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9763",
    "data-name": "Rectangle 9763",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 47,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.931,0c1.537,0,6.93.262,6.93,2.908S8.469,5.823,6.931,5.823,0,5.554,0,2.908,5.393,0,6.931,0",
    transform: "translate(9.467 42.177)",
    fill: "#003f85",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20006",
    "data-name": "Path 20006",
    d: "M1.522,0H3.044c.841,0,1.522,1.573,1.522,3.514,0,23.025-2.45,24.766-2.45,24.766S0,26.539,0,3.514C0,1.573.681,0,1.522,0Z",
    transform: "translate(14.115 16.596)",
    fill: "#212121"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23531",
    "data-name": "Group 23531",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1392",
    "data-name": "Ellipse 1392",
    cx: 11.4,
    cy: 11.4,
    r: 11.4,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19983",
    "data-name": "Path 19983",
    d: "M-20108.158-15914.8a8.6,8.6,0,0,1,7.256-9.836",
    transform: "translate(20112.84 15928.765)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.081800d1c96ffedd891183223c55076d.svg";
export { ForwardRef as ReactComponent };